<div *ngIf="question.introText" class="if-question-component-divider-container">
  <mat-divider [inset]="false"></mat-divider>
</div>
<div class="if-questions">
  <p
    class="if-questions-intro"
    *ngIf="question.introText"
    [translate]="question.introText"
  ></p>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="space-evenly center"
    fXFlexFill
    fxLayoutGap="20px grid"
  >
    <mmx-question
      *ngFor="let question of question.ifQuestions"
      class="child-question"
      [fxFlex]="question.flex"
      [fxFlex.xs]="100"
      [question]="question"
      [form]="form"
      [parent]="self"
    ></mmx-question>
  </div>
</div>
